import { getErrorMessage } from '@/shared/lib'
import { Profile } from '@/shared/store/useAppStore'
import { useLoginAndProfileRepository } from '@/features/repositories/useLoginAndProfileRepository'

export const useFetchAndSetProfiles = (
    callback: (profiles: Profile[]) => void
): { fetchAndSetProfiles: () => void } => {
    const { fetchUserProfiles } = useLoginAndProfileRepository()
    const fetchAndSetProfiles = async () => {
        try {
            const profilesData = (await fetchUserProfiles()) as Profile[]
            callback(profilesData)
        } catch (error) {
            getErrorMessage('ProfileMenu', error)
        }
    }
    return { fetchAndSetProfiles }
}
